var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.13289 2.32354L2.21967 2.21967C2.48002 1.95932 2.88416 1.93039 3.17646 2.13289L3.28033 2.21967L8 6.9395L12.7197 2.21967C13.0126 1.92678 13.4874 1.92678 13.7803 2.21967C14.0732 2.51256 14.0732 2.98744 13.7803 3.28033L9.0605 8L13.7803 12.7197C14.0407 12.98 14.0696 13.3842 13.8671 13.6765L13.7803 13.7803C13.52 14.0407 13.1158 14.0696 12.8235 13.8671L12.7197 13.7803L8 9.0605L3.28033 13.7803C2.98744 14.0732 2.51256 14.0732 2.21967 13.7803C1.92678 13.4874 1.92678 13.0126 2.21967 12.7197L6.9395 8L2.21967 3.28033C1.95932 3.01998 1.93039 2.61584 2.13289 2.32354L2.21967 2.21967L2.13289 2.32354Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.6b9573459022005d9400671a33633177.svg";
export { ForwardRef as ReactComponent };